/**
 * MegaMenuTabsSidebar
 * Custom element that handles tab switching within a tabbed mega-menu.
 *
 * setTimeout is required in connectedCallback so that child buttons are
 * fully parsed before we query them (custom element lifecycle fires before
 * children are appended during HTML parsing).
 */
class MegaMenuTabsSidebar extends HTMLElement {
  connectedCallback() {
    setTimeout(() => this.init());
  }

  init() {
    this.querySelectorAll('[data-mega-tab]').forEach((tab) => {
      tab.addEventListener('mouseenter', () => this.activateTab(tab));
      tab.addEventListener('click', () => this.activateTab(tab));
    });

    this.querySelectorAll('button:not([data-mega-tab])').forEach((tab) => {
      tab.addEventListener('mouseenter', () => this.activateEmptyTab(tab));
    });

    // Show the first panel that has a linked tab
    const firstLinkedTab = this.querySelector('[data-mega-tab]');
    if (firstLinkedTab) this.activateTab(firstLinkedTab);
  }

  activateTab(activeTab) {
    const panelId = activeTab.dataset.megaTab;
    const megaMenu = this.closest('header-mega-menu');
    if (!megaMenu) return;

    this.querySelectorAll('button').forEach((tab) => {
      const isActive = tab === activeTab;
      tab.classList.toggle('is-active', isActive);
      tab.setAttribute('aria-selected', isActive);
    });

    megaMenu.querySelectorAll('.mega-menu__panel').forEach((panel) => {
      if (panel.id === panelId) {
        panel.removeAttribute('hidden');
      } else {
        panel.setAttribute('hidden', '');
      }
    });
  }

  activateEmptyTab(activeTab) {
    const megaMenu = this.closest('header-mega-menu');
    if (!megaMenu) return;

    this.querySelectorAll('button').forEach((tab) => {
      const isActive = tab === activeTab;
      tab.classList.toggle('is-active', isActive);
      tab.setAttribute('aria-selected', isActive);
    });

    megaMenu.querySelectorAll('.mega-menu__panel').forEach((panel) => {
      panel.setAttribute('hidden', '');
    });
  }
}

if (!customElements.get('mega-menu-tabs-sidebar')) {
  customElements.define('mega-menu-tabs-sidebar', MegaMenuTabsSidebar);
}

/**
 * Drawer promo switcher
 * On tap of a sub-link in tabbed drawer mode, shows the matching promo block
 * and hides all others within the same panel.
 */
document.addEventListener('click', (event) => {
  const link = event.target.closest('.drawer-promo-switch');
  if (!link) return;

  const panelId = link.dataset.promoPanel;
  const blockId = link.dataset.promoBlock;
  if (!panelId || !blockId) return;

  // Switch promo block
  document.querySelectorAll(`[id^="${panelId}-"]`).forEach((el) => {
    if (el.id === `${panelId}-${blockId}`) {
      el.removeAttribute('hidden');
    } else {
      el.setAttribute('hidden', '');
    }
  });

  // Active state: bold the tapped link, reset siblings
  const panel = link.closest('header-menu-drawer-panel');
  if (panel) {
    panel.querySelectorAll('.drawer-promo-switch').forEach((el) => {
      el.classList.toggle('drawer-promo-switch--active', el === link);
    });
  }
});
